import { useState, useEffect } from 'react';
import get from 'lodash.get';
import Box from '../Box';
import PlaidInfoPanel from './Plaid/InfoPanel';
import PlaidEditForm from './Plaid/EditForm';
import ComplexPanel from './ComplexPanel';
import support from 'constants/config/support';
import isComplex from './utils/isComplex';
import ErrorBoundary from 'components/ErrorBoundary';
import useFeatureFlags from 'hooks/useFeatureFlags';

const DirectDeposit = props => {
  const { isEnabled } = useFeatureFlags();
  const [edit, setEdit] = useState(false);
  const { profile, mappings, update } = props;
  const { oAuthState, removeRestriction } = props;
  const loanoutsEnabled = isEnabled('MyCnC-LoanOuts');
  const { basicInfo: info } = profile || {};
  const directDeposits = (get(profile, 'directDeposits', []) || []).filter(
    d => (d.forCorps || '').toLowerCase() !== 'c',
  );
  const isComplexDDSetup = loanoutsEnabled
    ? false
    : get(profile, 'basicInfo.isComplexDDSetup', false);
  let updateDirectDeposits = directDeposits;
  const [enabled, setEnabled] = useState(
    (directDeposits && directDeposits.length > 0) || Boolean(oAuthState),
  );
  const supportInfo = support.helpDesk;
  const complex = (info.countryFlag || '').startsWith('CA')
    ? false
    : isComplexDDSetup || isComplex(directDeposits);

  const onEdit = () => setEdit(true);
  const cancel = () => {
    setEdit(false);
    updateDirectDeposits = (get(profile, 'directDeposits', []) || []).filter(
      d => (d.forCorps || '').toLowerCase() !== 'c',
    );
    setEnabled(directDeposits && directDeposits.length > 0);
  };

  useEffect(() => {
    setEnabled(
      (directDeposits && directDeposits.length > 0) || Boolean(oAuthState),
    );
  }, [profile]);

  useEffect(() => {
    if (oAuthState) {
      setEdit(true);
      setTimeout(() => {
        const parent = document.getElementById('Home');
        const header = document.getElementById('ProfileHeader');
        const target = document.getElementById(`ProfileBox-DirectDeposit`);
        const top = target.offsetTop - header.offsetTop;
        parent.scroll({ top });
      }, 100);
    }
  }, [oAuthState]);

  return (
    <Box title="Direct Deposit" onEdit={!complex && !edit && onEdit}>
      {complex ? (
        <ComplexPanel
          enabled={enabled}
          directDeposits={updateDirectDeposits}
          mappings={mappings}
          support={supportInfo}
        />
      ) : edit ? (
        <PlaidEditForm
          directDeposits={updateDirectDeposits}
          mappings={mappings}
          support={supportInfo}
          enabled={enabled}
          dbCode={info.dbCode}
          setEnabled={setEnabled}
          onCancel={cancel}
          onSave={update}
          oAuthState={oAuthState}
          removeRestriction={removeRestriction}
        />
      ) : (
        <ErrorBoundary alert>
          <PlaidInfoPanel
            enabled={enabled}
            directDeposits={updateDirectDeposits}
            mappings={mappings}
            support={supportInfo}
          />
        </ErrorBoundary>
      )}
    </Box>
  );
};

export default DirectDeposit;
